export default __webpack_public_path__ + "static/media/sign.6448017e.svg";